var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PromotionForm',{attrs:{"promotion":_vm.promotion,"formType":_vm.formType,"buttonLoading":_vm.buttonLoading},on:{"savePromotion":_vm.updatePromotion}})
}
var staticRenderFns = []

export { render, staticRenderFns }